// extracted by mini-css-extract-plugin
export default {"pager":"pager-widget__pager--2roil"};